import { render, staticRenderFns } from "./SearchAddNewPatient.vue?vue&type=template&id=4a7d884e&scoped=true&"
import script from "./SearchAddNewPatient.vue?vue&type=script&lang=js&"
export * from "./SearchAddNewPatient.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a7d884e",
  null
  
)

export default component.exports